import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-check-item-completed',
    templateUrl: './check-item-completed.component.html',
    styleUrls: ['./check-item-completed.component.scss'],
    standalone: false
})
export class CheckItemCompletedComponent {
  @Input() active = false;
  @Input() checked = false;
  @Input() enable = false;
  @Input() step = 0;
  @Input() label = "";
  /** Issue #520: renders a red asterisk after the label — set on the two mandatory rows (install_extension, about_you) only. */
  @Input() required = false;
  @Output() onClick = new EventEmitter<void>();

  constructor() { }

  setStep() {
    // Issue #523: a completed row must always stay clickable/revisitable —
    // don't rely on `enable` alone (it gates SEQUENTIAL reachability of
    // not-yet-done rows; a row that's already `checked` is reachable by
    // definition, regardless of how `enable` was computed upstream).
    if (!this.enable && !this.checked) {
      return;
    }

    if (this.onClick) {
      this.onClick.emit();
    }
  }
}
